import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import * as VueGoogleMaps from "vue2-google-maps";
//import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH, SET_AUTH } from "@/core/services/store/auth.module";
import { UPDATE_PERSONAL_INFO, UPDATE_ADMIN_INFO } from "@/core/services/store/profile.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Permissions from "./core/plugins/permissions";
import Subscription from "./core/plugins/Subscription";
import { migrateAuthStorage, authGet } from "@/core/services/auth-storage";

document.title = "GetMeFood";
migrateAuthStorage();

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/assets/plugins/flaticon2/flaticon.css";
import "@/core/plugins/formvalidation";

// API service init
ApiService.init();

router.afterEach((to) => {
  const page = to.meta && to.meta.title;
  document.title = page ? `${page} | GetMeFood` : "GetMeFood";
});

router.beforeEach((to, from, next) => {
  let userAuth = authGet('USER_STATE');
  let authParsed = null;
  try {
    authParsed = userAuth ? JSON.parse(userAuth) : null;
  } catch (e) {
    authParsed = null;
  }

  if (authParsed) {
    store.commit(SET_AUTH, authParsed);
  }

  next();

  if (authParsed && authParsed.normal) {
    store.dispatch(UPDATE_PERSONAL_INFO);
  } else if (authParsed && authParsed.user) {
    store.dispatch(UPDATE_ADMIN_INFO, authParsed.user);
  }
  store.dispatch(SET_BREADCRUMB, []);
  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
Vue.use(Permissions); // Add this line
Vue.use(Subscription)
Vue.use(VueGoogleMaps);
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
